import styled from "styled-components";

export const SupplierFeeManagementWrapper = styled.div`
  font-family: "latomedium";
  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .tab-wrapper {
    display: flex;
  }

  .tab-name {
    padding: 5px 10px;
    border-radius: 5px 5px 0px 0px;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #7A7A7A;
    margin: 0;
  }

  .tab-name.active {
    color: #000000;
    border-bottom-color: #2982CC;
    background: #fff;
  }

  .global-updated-date {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
    padding: 5px;
  }
`;

export const GloablFeeWrapperWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  padding: 24px;
  margin-top: 10px;    

  .instructions {
    font-size: 13px;
    background: #DFF2FE;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px 5px 0 0;
    padding: 10px;
    gap: 20px;
    margin-bottom: 15px;
    color: #00000080;
  }

  input, textarea{
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
    font-size: 14px;
    height: 30px;
    padding-left: 5px;
    color: #00000091;      
  }

  input:disabled, textarea:disabled {
    background: #fff;
    border: none !important;
    border-bottom: 1px solid #e1e1e1 !important;
    opacity: 0.7;
  }

  .app-input-text {
    margin-bottom: 0px;
    .error{
      border: none !important;
      border-bottom: 1px solid #e1e1e1 !important;
    } 
  }

  .global-fee-section{
    margin-bottom: 15px;
  }

  .global-fee-section:last-child {
    margin-bottom: 0;
  }

  .global-fee-section-title {
    font-size: 15px;
    font-family: 'latobold';
    color: #1f2937;
    margin-bottom: 16px;
    margin-top: 0;
  }

  .fee-wrapper {
    display: flex;
    flex-direction: column;
  }

  .form-field {
    display: flex;
    align-items: center;
  }

  .form-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 0px;
    width: 250px;
  }

  .form-value {
    display: flex;
    color: #00000091;
    font-size: 14px;
    align-items: center;
    input {
      width: 75px !important;
    }
  }

  .comments-styling{
    margin-bottom: 10px;
    align-items: flex-start;
  }

  .form-value-text-area{
    width: 70%;
    textarea{
      height: 50px;
      border: 1px solid #e1e1ee !important;
      padding: 5px;
    }
  }

  .error-message{
    margin: 0;
    font-size: 12px;
    color: red;
    font-family: 'latoregular';
  }

  .button-group {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 25px 0;
    button {
      background: #074269;
      padding: 20px;
      font-size: 14px;
    }
  }
`;

export const GlobalTermsFeeTableWrapper = styled.div`
  .date-time {
    white-space: nowrap;
  }
  .table-responsive {
    max-height: 300px;
    thead{
      position: sticky;
      top: -1px;
      z-index: 2;
      background: #fff;
      height: 45px;
      box-shadow: 0 1px 0 #e1e1e1;
    }
    th, td {
      padding: 8px
    }
    th {
      padding-top: 12px;
    }
  }
  .comments {
    display: flex;
    justify-content: center;
    padding-top: 2px;
  }
`;

export const SupplierTermsFeeWrapper = styled.div`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  padding: 24px;
  margin: 10px 0;    

  .instructions {
    font-size: 13px;
    background: #DFF2FE;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px 5px 0 0;
    padding: 10px;
    gap: 20px;
    margin-bottom: 15px;
    color: #00000080;
  }

  input, textarea{
    border: none;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 0;
    padding: 0;
    font-size: 14px;
    height: 30px;
    padding-left: 5px;
    color: #00000091;      
  }

  input:disabled, textarea:disabled {
    background: #fff;
    border: none !important;
    border-bottom: 1px solid #e1e1e1 !important;
  }

  .app-input-text {
    margin-bottom: 0px;
    .error{
      border: none !important;
      border-bottom: 1px solid #e1e1e1 !important;
    } 
  }

  .global-fee-section{
    margin-bottom: 15px;
  }

  .global-fee-section:last-child {
    margin-bottom: 0;
  }

  .global-fee-section-title {
    font-size: 15px;
    font-family: 'latobold';
    color: #1f2937;
    margin-bottom: 16px;
    margin-top: 0;
  }

  .location-details{
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 14px;
    margin-bottom: 25px;
    .no-users{
      font-style: italic;
    }
  }

  .fee-wrapper {
    display: flex;
    flex-direction: column;
  }

  .form-field-wrapper {
    display: flex;
    gap: 50px;
  }

  .form-field {
    display: flex;
    align-items: center;
  }

  .form-label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 0px;
    width: 250px;
  }

  .form-value {
    display: flex;
    color: #00000091;
    font-size: 14px;
    align-items: center;
    input {
      width: 75px !important;
    }
  }

  .discount-rate{
    width: 100px;
  }

  .comments-styling{
    margin-bottom: 10px;
    align-items: flex-start;
  }

  .form-value-text-area{
    width: 70%;
    textarea{
      height: 50px;
      border: 1px solid #e1e1ee !important;
      padding: 5px;
    }
  }

  .error-message{
    margin: 0;
    font-size: 12px;
    color: red;
    font-family: 'latoregular';
  }

  .button-group {
    display: flex;
    justify-content: center;
    margin-top: 25px;
    gap: 12px;
    button {
      background: #074269;
      padding: 20px;
      font-size: 14px;
    }
  }

  .supplier-select__control {
    border: 1px solid #e1e1e1 !important;
    border-radius: 5px !important;
    box-shadow: none !important;
    width: 400px;
    cursor: pointer;
    font-size: 14px;
  }

  .supplier-select__menu {
    width: 400px !important;
    min-width: 400px !important;
    max-width: 400px !important;
    font-family: 'latoregular';
    font-size: 14px;
  }

  .supplier-select__control:hover {
    border-bottom: 1px solid #e1e1e1 !important;
  }

  .supplier-select__control--is-focused {
    border-bottom: 1px solid #e1e1e1 !important;
  }

  .supplier-select__value-container{
    width : 100%;
  }

  .supplier-select__value-container > div:last-child {
    width: 100%;
  }

  .supplier-select__input {
    width : 100%;
    font-size: 14px;
    font-family: 'latoregular';
  }

  .supplier-select__indicator-separator {
    display: none !important;
  }

  .supplier-select__placeholder{
    font-size: 14px;
  }

  .global-terms-table{
    font-size: 14px;
    .global-terms-header{
      font-size: 14px;
      font-family: 'latobold';
    }

    .table-responsive {
      border: 1px solid #d5cfcf;
      border-radius: 10px;
      margin: 10px 0;
    }

    .global-terms-table-header {
      th{
        white-space: nowrap;
        padding: 10px 5px;
        font-family: 'latobold';
      }
      th:first-child {
        padding-left: 10px;
      }
    }

    .global-terms-table-content {
      td{
        white-space: nowrap;
        padding: 10px 5px;      
      }
      td:first-child {
        padding-left: 10px;
      }
    }

    table {
      margin: 0;
    }

    thead {
      border-bottom: 1px solid #d5cfcf;
      th {
        border-bottom: none;
        border-top: none;
      }
    }
  }
`;

export const SupplierTermsFeeTableWrapper = styled.div`
  .search-submit, .export {
    background: linear-gradient(rgb(97, 176, 31) 0%, rgb(39, 145, 27) 100%);
    color: white;
    white-space: nowrap;
    border: 0px;
    border-radius: 5px;
    padding: 5px 15px;
    margin: 2px;
    cursor: pointer;
  }

  .is-exporting {
    opacity: 0.5;
    font-style: italic;
  }

  .table-responsive {
    th, td {
      padding: 8px
    }
  }

  .ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    display: block;
  }

  .comments {
    display: flex;
    justify-content: center;
    padding-top: 2px;
  }

  .date-time{
    white-space: nowrap;
  }

  .no-records {
    text-align: center;
  }

  .action-buttons{
    display: flex;
    gap: 3px;
    svg{
      height: 21px;
      width: 21px;
      cursor: pointer;
    }
    .editicon{
      svg{
        height: 18px;
      }
    }
  }
`;